<template>
  <b-container fluid class="p__t--30">
    <b-row v-if="!loading_list">
      <b-col
        cols="12"
        sm="6"
        md="4"
        v-for="(data, index) in attractionState.list"
        :key="index"
      >
        <div
          class="h--208 w__100 background-thema m__b--30"
          @click="
            $router.replace(`/cashier/order/attraction/create/${data.id}`)
          "
          :style="{ background: $randomColor({ luminosity: 'dark' }) }"
        >
          <b-container fluid class="naming">
            <span>{{ data.name }}</span>
            <br />
            <span class="f--16 c--grey">{{
              data.location_id ? data.location_id.name : '-'
            }}</span>
          </b-container>
        </div>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col cols="12" sm="6" md="4" v-for="(data, index) in 6" :key="index">
        <div class="h--208 w__100 background-thema m__b--30">
          <ListLoading />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import ListLoading from '@/components/Loading/ListLoading';

export default {
  name: 'order',
  components: {
    ListLoading
  },
  data() {
    return {
      loading_list: false
    };
  },
  created() {
    const req = {
      sort: '',
      per_page: 0,
      page: 0,
      search: ''
    };
    this.$store.dispatch('StoreAttraction/listAttraction', req);

    if (this.attractionState.list.length === 0) {
      this.loading_list = true;
    }
  },
  watch: {
    'attractionState.list'() {
      this.loading_list = false;
    }
  },
  computed: {
    ...mapState('StoreAttraction', ['attractionState'])
  }
};
</script>

<style lang="scss">
.background-thema {
  position: relative;
  transition: box-shadow 0.2s ease;
  cursor: pointer;
  &:hover {
    transition: box-shadow 0.2s ease;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  }
  .naming {
    color: white;
    position: absolute;
    bottom: 15px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
  }
}
</style>
